'use strict';

/**
 *
 * @name: youtube
 *
 */

import DirectiveTemplate from './nn-player-youtube.directive.html';

function YoutubeDirective($sce, $rootScope, localPlaylist, $timeout, $interval) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      videoId: '@'
    },
    link: function(scope, element) {

      var playerName = 'youtube-player' + scope.videoId;
      scope.player = null;
      var detached = true;

      if (element[0].parentNode.nodeName === 'DIV') {

        detached = false;
      }

      if (detached) {

        element.parents().remove();
        element.remove();
        scope.$destroy();
      }

      if (!detached) {

        $timeout(function() {

          scope.player = new YT.Player(playerName, {
            height: '100%',
            width: '100%',
            videoId: scope.videoId,
            playerVars: {
              autoplay: 0,
              showinfo: 0,
              origin: $rootScope.appDist
            },
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          });
        }, 500);
      }

      function updatePlayerInfo() {

        if (!detached && scope.player && scope.player.getDuration) {

          var counter = Math.floor(scope.player.getDuration() - scope.player.getCurrentTime());

          if (counter < 0) {

            counter = 0;
          }

          if (counter < 888888) {

            localPlaylist.updateCounter(counter);
          }
        }
      }

      var myInterval;

      function onPlayerReady() {

        if (!detached) {

          $rootScope.noPlayer = false;
          myInterval = $interval(updatePlayerInfo, 250);
        }
      }

      var firstTimeOnly = false;

      function onPlayerStateChange(event) {

        if (!detached && event.data === YT.PlayerState.ENDED && !firstTimeOnly) {

          $rootScope.noPlayer = true;
          $rootScope.showPersistentVideo = false;
          firstTimeOnly = true;
          $interval.cancel(myInterval);
          $rootScope.$broadcast('filmDun');

        }
      }

      var youtubeFinishedListener = $rootScope.$on('filmFinished', function() {

        void 0;
        $rootScope.noPlayer = true;
        youtubeFinishedListener();
        void 0;

        if (!detached) {

          scope.player.destroy();
        }

        $interval.cancel(myInterval);
        scope.$destroy();
        element.remove();
      });

      scope.$on('$destroy', function() {

        $interval.cancel(myInterval);
        element.find('*').remove();
      });
    }
  };
}

export default YoutubeDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-player-youtube/nn-player-youtube.directive.js